<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header d-flex justify-content-between align-items-center">
        <div>
          <h3 class="page-title">
            <i class="fa fa-calendar-check-o mr-2 text-primary"></i>
            Chấm công nhanh (Admin)
          </h3>
          <div class="text-muted small">
            Chọn nhân viên, chọn ngày, bấm nút. Sửa đời người trong 3 click.
          </div>
        </div>

        <div class="d-flex align-items-center">
          <input v-model="month" type="month" class="form-control mr-2" style="width: 180px" />
          <button class="btn btn-outline-secondary" @click="load" :disabled="loading">
            <i class="fa fa-refresh mr-1"></i> Tải
          </button>
        </div>
      </div>

      <!-- FILTER -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-2">
              <label class="small text-muted font-weight-bold">Tìm nhân viên</label>
              <input v-model.trim="keyword" class="form-control" placeholder="Tên / tài khoản..." />
            </div>

            <div class="col-md-4 mb-2">
              <label class="small text-muted font-weight-bold">Chọn nhân viên</label>

              <!-- ✅ FIX: bỏ .number để tránh null => 0 -->
              <select v-model="selectedUserId" class="form-control">
                <option value="">-- Chọn --</option>
                <option v-for="r in rows" :key="r.userId" :value="String(r.userId)">
                  {{ r.hoTen }} ({{ r.phongBan || "N/A" }})
                </option>
              </select>
            </div>

            <div class="col-md-4 mb-2 d-flex align-items-end">
              <button class="btn btn-outline-dark mr-2" @click="selectAllWorkdays" :disabled="!selectedRow">
                <i class="fa fa-check-square-o mr-1"></i> Chọn tất cả ngày làm việc
              </button>
              <button class="btn btn-outline-danger" @click="clearSelection">
                <i class="fa fa-times mr-1"></i> Bỏ chọn
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- GRID -->
      <div class="card mb-3" v-if="selectedRow">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="font-weight-bold">
              {{ selectedRow.hoTen }}
              <span class="text-muted small">({{ selectedRow.kieuChamCong }})</span>
            </div>
            <div class="text-muted small">
              Đã chọn: <b>{{ selectedDates.length }}</b> ngày
            </div>
          </div>

          <div class="grid-month">
            <button
              v-for="cell in (selectedRow.daily || [])"
              :key="cell.day"
              class="day-cell"
              :class="dayCellClass(cell)"
              @click="toggleDay(cell)"
              :title="cellTooltip(cell)"
            >
              <div class="day-num">{{ cell.day }}</div>
              <div class="day-mini">
                <span v-if="cell.holiday" class="badge badge-warning">Lễ</span>
                <span v-else-if="cell.sunday" class="badge badge-info">CN</span>
                <span v-else class="badge badge-light">{{ cell.status }}</span>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- ACTION BAR -->
      <div class="card" v-if="selectedRow">
        <div class="card-body d-flex flex-wrap align-items-center">
          <button class="btn btn-primary mr-2 mb-2" @click="openAttendance">
            <i class="fa fa-plus mr-1"></i> Bổ sung chấm công nhanh
          </button>
          <button class="btn btn-outline-primary mr-2 mb-2" @click="openOvertime">
            <i class="fa fa-clock-o mr-1"></i> Bổ sung lệnh tăng ca nhanh
          </button>
          <button class="btn btn-outline-success mr-2 mb-2" @click="openSunday">
            <i class="fa fa-sun-o mr-1"></i> Bổ sung lệnh CN nhanh
          </button>

          <div class="ml-auto text-muted small">
            Tip: OT ngày thường chỉ tính từ <b>18:00</b> đến <b>21:00</b>. CN thì đừng cố, hệ thống cũng không tin bạn.
          </div>
        </div>
      </div>

      <!-- RESULT -->
      <div class="mt-3" v-if="result">
        <div class="alert alert-info mb-2">
          <b>KQ:</b> OK {{ result.successCount }}, SKIP {{ result.skipCount }}, ERROR {{ result.errorCount }}
        </div>
        <div class="card">
          <div class="card-body">
            <div v-for="it in (result.items || [])" :key="it.date + it.status" class="small mb-1">
              <b>{{ it.date }}</b>
              -
              <span
                :class="it.status==='SUCCESS'?'text-success':it.status==='SKIP'?'text-muted':'text-danger'"
              >
                {{ it.status }}
              </span>
              <span class="text-muted">: {{ it.message }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- MODALS -->
      <!-- Attendance -->
      <div class="modal fade show d-block" tabindex="-1" v-if="modal==='ATT'">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bổ sung chấm công nhanh</h5>
              <button type="button" class="close" @click="modal=null"><span>&times;</span></button>
            </div>
            <div class="modal-body">
            <div class="row" v-if="show4MocInputs">
  <div class="col-md-3 mb-2">
    <label class="small text-muted font-weight-bold">Sáng vào</label>
    <input v-model="att.sangVao" type="time" class="form-control" />
  </div>
  <div class="col-md-3 mb-2">
    <label class="small text-muted font-weight-bold">Sáng ra</label>
    <input v-model="att.sangRa" type="time" class="form-control" />
  </div>
  <div class="col-md-3 mb-2">
    <label class="small text-muted font-weight-bold">Chiều vào</label>
    <input v-model="att.chieuVao" type="time" class="form-control" />
  </div>
  <div class="col-md-3 mb-2">
    <label class="small text-muted font-weight-bold">Chiều ra</label>
    <input v-model="att.chieuRa" type="time" class="form-control" />
  </div>
</div>

<div class="alert alert-light border small py-2 mb-2" v-else>
  Đang chấm theo ngày (07:00–17:00). Không cần 4 mốc.
</div>


              <div class="mt-2">
                <label class="small text-muted font-weight-bold d-block mb-1">Chế độ chấm công nhanh</label>
              <div class="d-flex flex-wrap">
  <label class="mr-3">
    <input type="radio" value="TU_DONG" v-model="att.cheDo" />
    Tự động theo phòng ban
  </label>

  <label class="mr-3">
    <input
      type="radio"
      value="NGAY_07_17"
      v-model="att.cheDo"
      :disabled="isDeptBuoi2x2"
      :title="isDeptBuoi2x2 ? 'Phòng ban đang 2 buổi, không nên chấm FULL 07-17' : ''"
    />
    Chấm công ngày (07:00–17:00)
  </label>

  <label class="mr-3">
    <input
      type="radio"
      value="BUOI_4_MOC"
      v-model="att.cheDo"
      :disabled="!isDeptBuoi2x2"
      :title="!isDeptBuoi2x2 ? 'Phòng ban không 2 buổi, không nên chấm 4 mốc' : ''"
    />
    Chấm đủ 4 mốc (Sáng + Chiều)
  </label>
</div>

<div class="text-muted small mt-2">
  <i class="fa fa-info-circle mr-1"></i>
  {{ deptHintText }}
</div>



                <div class="text-muted small mt-1">
                  Lưu ý: Chế độ 07:00–17:00 sẽ ghi vào <b>Buổi FULL</b> để không bị hiểu nhầm “ra ca sáng 17:00 = trễ”.
                </div>
              </div>


              <div class="d-flex flex-wrap mt-2">
                <label class="mr-3">
                  <input type="checkbox" v-model="att.skipHoliday" /> Bỏ ngày lễ
                </label>
                <label class="mr-3">
                  <input type="checkbox" v-model="att.allowSunday" /> Cho phép Chủ nhật (chỉ XƯỞNG)
                </label>
                <label class="mr-3">
                  <input type="checkbox" v-model="att.overrideExisting" /> Ghi đè nếu đã có
                </label>
              </div>

              <div class="text-muted small mt-2">
                Chế độ chấm công (2 lần hay 1 lần) sẽ tự theo <b>KieuChamCong</b> của phòng ban.
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="modal=null">Đóng</button>
              <button class="btn btn-primary" @click="submitAttendance" :disabled="selectedDates.length===0 || submitting">
                Tạo cho {{ selectedDates.length }} ngày
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Overtime -->
      <div class="modal fade show d-block" tabindex="-1" v-if="modal==='OT'">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bổ sung lệnh tăng ca nhanh</h5>
              <button type="button" class="close" @click="modal=null"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <label class="small text-muted font-weight-bold">Checkout thực tế</label>
              <input v-model="ot.checkoutTime" type="time" class="form-control" />

              <div class="mt-2">
                <label>
                  <input type="checkbox" v-model="ot.skipHoliday" /> Bỏ ngày lễ
                </label>
              </div>

              <div class="text-muted small mt-2">
                OT = min(checkout, 21:00) - 18:00. Chủ nhật tự skip.
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="modal=null">Đóng</button>
              <button class="btn btn-outline-primary" @click="submitOvertime" :disabled="selectedDates.length===0 || submitting">
                Tạo OT cho {{ selectedDates.length }} ngày
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Sunday -->
      <div class="modal fade show d-block" tabindex="-1" v-if="modal==='SUN'">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bổ sung lệnh CN nhanh</h5>
              <button type="button" class="close" @click="modal=null"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6 mb-2">
                  <label class="small text-muted font-weight-bold">Giờ vào (optional)</label>
                  <input v-model="sun.gioVao" type="time" class="form-control" />
                </div>
                <div class="col-6 mb-2">
                  <label class="small text-muted font-weight-bold">Giờ ra (optional)</label>
                  <input v-model="sun.gioRa" type="time" class="form-control" />
                </div>
              </div>

              <div class="d-flex flex-wrap mt-2">
                <label class="mr-3">
                  <input type="checkbox" v-model="sun.skipHoliday" /> Bỏ ngày lễ
                </label>
                <label class="mr-3">
                  <input type="checkbox" v-model="sun.onlySundays" /> Chỉ Chủ nhật
                </label>
              </div>

              <div class="text-muted small mt-2">
                Nếu không nhập giờ: mặc định preset 07:00–17:00 và tính tiền theo 2 block (max 500k).
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="modal=null">Đóng</button>
              <button class="btn btn-outline-success" @click="submitSunday" :disabled="selectedDates.length===0 || submitting">
                Tạo CN cho {{ selectedDates.length }} ngày
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-backdrop fade show" v-if="modal"></div>
    </div>
  </div>
</template>

<script>
import adminQuickChamCongService from "@/services/adminQuickChamCongService";

export default {
  name: "AdminChamCongQuick",
  data() {
    const ym = new Date();
    const month = `${ym.getFullYear()}-${String(ym.getMonth() + 1).padStart(2, "0")}`;
    return {
      month,
      keyword: "",
      loading: false,
      rows: [],

      selectedUserId: "",
      selectedDaysMap: {},

      modal: null,
      submitting: false,
      result: null,

      att: {
        cheDo: "TU_DONG", // "TU_DONG" | "NGAY_07_17" | "BUOI_4_MOC"
        sangVao: "07:00",
        sangRa: "11:30",
        chieuVao: "13:00",
        chieuRa: "17:00",
        skipHoliday: true,
        allowSunday: false,
        overrideExisting: false,
      },
      ot: {
        checkoutTime: "19:00",
        skipHoliday: true,
      },
      sun: {
        gioVao: "",
        gioRa: "",
        skipHoliday: true,
        onlySundays: true,
      },
    };
  },

  computed: {
    selectedRow() {
      const id = Number(this.selectedUserId);
      if (!id) return null;
      return this.rows.find((r) => r.userId === id) || null;
    },

    selectedDates() {
      const map = this.selectedDaysMap && typeof this.selectedDaysMap === "object" ? this.selectedDaysMap : {};
      return Object.keys(map).filter((k) => map[k]).sort();
    },

    // ✅ NEW: phòng ban đang chấm mấy buổi?
    isDeptBuoi2x2() {
      return this.selectedRow?.kieuChamCong === "BUOI_2x2";
    },

    // ✅ NEW: chế độ FE nên đề xuất (để khỏi mismatch)
    suggestedCheDo() {
      return this.isDeptBuoi2x2 ? "BUOI_4_MOC" : "NGAY_07_17";
    },

    // ✅ NEW: hiển thị input 4 mốc chỉ khi đang chấm 4 mốc
    show4MocInputs() {
      // Nếu bạn muốn TU_DONG cũng hiển thị theo phòng ban thì:
      if (this.att.cheDo === "TU_DONG") return this.isDeptBuoi2x2;
      return this.att.cheDo === "BUOI_4_MOC";
    },

    // ✅ NEW: disable radio trái phòng ban (đỡ bấm nhầm)
    disableNgay0717() {
      // phòng ban 2 buổi thì đừng cho chọn NGAY_07_17 (trừ TU_DONG)
      return this.isDeptBuoi2x2 && this.att.cheDo !== "TU_DONG";
    },
    disableBuoi4Moc() {
      // phòng ban 1 lần/full thì đừng cho chọn BUOI_4_MOC (trừ TU_DONG)
      return !this.isDeptBuoi2x2 && this.att.cheDo !== "TU_DONG";
    },

    // ✅ NEW: text nhắc
    deptHintText() {
      if (!this.selectedRow) return "";
      return this.isDeptBuoi2x2
        ? "Phòng ban đang chấm 2 buổi (BUOI_2x2) → đề xuất Chấm đủ 4 mốc."
        : "Phòng ban đang chấm theo ngày → đề xuất Chấm công ngày (07:00–17:00).";
    },
  },

  methods: {
    async load() {
      this.loading = true;
      this.result = null;
      try {
        const res = await adminQuickChamCongService.adminMatrix({
          month: this.month,
          keyword: this.keyword || null,
          phongBanId: null,
        });
        this.rows = res?.data?.rows || [];
      } catch (e) {
        console.error(e);
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },

    cellDate(cell) {
      const [y, m] = this.month.split("-").map(Number);
      const d = String(cell.day).padStart(2, "0");
      return `${y}-${String(m).padStart(2, "0")}-${d}`;
    },

    toggleDay(cell) {
      if (!this.selectedRow) return;
      const date = this.cellDate(cell);
      const cur = this.selectedDaysMap && typeof this.selectedDaysMap === "object" ? this.selectedDaysMap : {};
      this.selectedDaysMap = { ...cur, [date]: !cur[date] };
    },

    clearSelection() {
      this.selectedDaysMap = {};
      this.result = null;
    },

    selectAllWorkdays() {
      if (!this.selectedRow) return;
      const map = {};
      for (const cell of this.selectedRow.daily || []) {
        if (cell.sunday) continue;
        if (cell.holiday) continue;
        map[this.cellDate(cell)] = true;
      }
      this.selectedDaysMap = map;
    },

    dayCellClass(cell) {
      const date = this.cellDate(cell);
      const selected = !!(this.selectedDaysMap && this.selectedDaysMap[date]);
      return {
        selected,
        sunday: !!cell.sunday,
        holiday: !!cell.holiday,
        present: cell.status === "FULL" || cell.status === "HALF_AM" || cell.status === "HALF_PM",
        open: cell.status === "OPEN",
      };
    },

    cellTooltip(cell) {
      const date = this.cellDate(cell);
      return `${date} | ${cell.status}${cell.holiday ? " | Lễ" : ""}${cell.sunday ? " | CN" : ""}`;
    },

    // ✅ UPDATED: khi mở modal -> auto chọn chế độ theo phòng ban
    openAttendance() {
      this.modal = "ATT";
      this.result = null;

      // auto align theo phòng ban để khỏi mismatch
      this.att.cheDo = this.suggestedCheDo;

      // nếu là NGAY_07_17 thì không cần chỉnh giờ 4 mốc (nhưng giữ default để lần sau)
      // còn nếu BUOI_4_MOC thì show input, user chỉnh thoải mái
    },

    openOvertime() { this.modal = "OT"; this.result = null; },
    openSunday() { this.modal = "SUN"; this.result = null; },

    async submitAttendance() {
      this.submitting = true;
      try {
        // ✅ quyết định thực tế gửi lên theo cheDo hiện tại
        const laNgay0717 = this.att.cheDo === "NGAY_07_17";
        const laBuoi4Moc = this.att.cheDo === "BUOI_4_MOC";

        const payload = {
          userId: Number(this.selectedUserId),
          dates: this.selectedDates,
          cheDo: this.att.cheDo,

          // ✅ NEW: chỉ gửi 4 mốc khi thật sự chấm 4 mốc.
          // NGAY_07_17: BE ép cứng 07-17 -> gửi null.
          // TU_DONG: nếu phòng ban là 2 buổi thì vẫn gửi 4 mốc (để admin override giờ theo ý).
          sangVao: (laNgay0717) ? null : ( (this.att.cheDo === "TU_DONG" && !this.isDeptBuoi2x2) ? null : this.att.sangVao ),
          sangRa:  (laNgay0717) ? null : ( (this.att.cheDo === "TU_DONG" && !this.isDeptBuoi2x2) ? null : this.att.sangRa ),
          chieuVao:(laNgay0717) ? null : ( (this.att.cheDo === "TU_DONG" && !this.isDeptBuoi2x2) ? null : this.att.chieuVao ),
          chieuRa: (laNgay0717) ? null : ( (this.att.cheDo === "TU_DONG" && !this.isDeptBuoi2x2) ? null : this.att.chieuRa ),

          skipHoliday: this.att.skipHoliday,
          allowSunday: this.att.allowSunday,
          overrideExisting: this.att.overrideExisting,
        };

        const res = await adminQuickChamCongService.quickAttendance(payload);
        this.result = res?.data || null;
        this.modal = null;
        await this.load();
      } catch (e) {
        console.error(e);
      } finally {
        this.submitting = false;
      }
    },

    async submitOvertime() {
      this.submitting = true;
      try {
        const payload = {
          userId: Number(this.selectedUserId),
          dates: this.selectedDates,
          checkoutTime: this.ot.checkoutTime,
          skipHoliday: this.ot.skipHoliday,
        };

        const res = await adminQuickChamCongService.quickOvertime(payload);
        this.result = res?.data || null;
        this.modal = null;
        await this.load();
      } catch (e) {
        console.error(e);
      } finally {
        this.submitting = false;
      }
    },

    async submitSunday() {
      this.submitting = true;
      try {
        const payload = {
          userId: Number(this.selectedUserId),
          dates: this.selectedDates,
          gioVao: this.sun.gioVao || null,
          gioRa: this.sun.gioRa || null,
          skipHoliday: this.sun.skipHoliday,
          onlySundays: this.sun.onlySundays,
        };

        const res = await adminQuickChamCongService.quickSunday(payload);
        this.result = res?.data || null;
        this.modal = null;
        await this.load();
      } catch (e) {
        console.error(e);
      } finally {
        this.submitting = false;
      }
    },
  },

  watch: {
    selectedUserId() {
      this.clearSelection();
    },
  },

  mounted() {
    this.load();
  },
};
</script>


<style scoped>
.grid-month {
  display: grid;
  grid-template-columns: repeat(10, minmax(72px, 1fr));
  gap: 8px;
}
.day-cell {
  border: 1px solid #e9ecef;
  background: #fff;
  border-radius: 10px;
  padding: 8px;
  text-align: left;
  cursor: pointer;
  transition: all 0.12s ease;
  min-height: 58px;
}
.day-cell:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(0,0,0,.06); }
.day-cell.selected { border-color: #007bff; box-shadow: inset 0 0 0 2px rgba(0,123,255,.15); }
.day-cell.sunday { background: #f7fbff; }
.day-cell.holiday { background: #fff9e6; }
.day-cell.present { border-color: #d4edda; }
.day-cell.open { border-color: #ffeeba; }

.day-num { font-weight: 700; font-size: 14px; }
.day-mini { margin-top: 6px; }
.badge { border-radius: 8px; }

.modal-backdrop { z-index: 1040; }
.modal { z-index: 1050; }
</style>
